import React, { useEffect, useState } from 'react';
import EditIcon from '../../../../Assets/OptionsModel/edit.svg';
import HomeIcon from "../../../../Assets/Account/home-city-outline.svg";
import StoreIcon from "../../../../Assets/Account/Store.svg";
import { getCachedMediaUrl, getInitials } from '../../../../lib/utils/utils';
import { getBusinessInfo } from '../../../../lib/utils/apiCalls';
import StoreInfoForm from './StoreInfoForm';

function SectionBox({ icon, title, value, border }) {
    const formattedValue = Array.isArray(value)
        ? value.join(", ")
        : value;

    return (
        <div className={`p-[10px] flex items-center gap-3 ${border && 'border-b border-[#EAEAEA]'}`}>
            <div className="size-6 flex items-center justify-center">
                <img src={icon} alt="" />
            </div>

            <div className="flex flex-col gap-1 font-medium">
                <h1 className='text-[14px] leading-5 text-[#808080]'>{title}</h1>

                <p className='text-[16px] leading-5 text-[#000000] capitalize'>{formattedValue}</p>
            </div>
        </div>
    )
}

function StoreInfo() {
    const [storeInfo, setStoreInfo] = useState({});
    const [editFormOpen, setEditFormOpen] = useState(false);

    function handleEditStoreInfo() {
        setEditFormOpen(true);
    }

    function handleCloseForm() {
        fetchStoreInfo();
        setEditFormOpen(false);
    }

    async function fetchStoreInfo() {
        try {
            const response = await getBusinessInfo();
            if(response.status === 200) {
                setStoreInfo({
                    img: response.data.data.img,
                    ...response.data.data.seller,
                });
            }
        }
        catch(err) {
            console.log(err);
        }
    }

    useEffect(() => {
        fetchStoreInfo();
    }, []);

    return (
        <div className='w-3/5 flex flex-col gap-4'>
            {
                editFormOpen ? 
                <StoreInfoForm 
                    storeInfo={storeInfo} 
                    closeForm={handleCloseForm}
                /> : 
                <div className="p-4 flex flex-col gap-4 rounded-xl border border-[#EAEAEA] shadow-[0_0_6px_0_#0000001F]">
                    <div className="flex items-center justify-between">
                        <h1 className='font-semibold text-[20px] leading-6 text-[#121212]'>Store Information</h1>

                        <button onClick={handleEditStoreInfo} className="outline-none size-6 flex items-center justify-center">
                            <img className='size-full' src={EditIcon} alt="" />
                        </button>
                    </div>

                    <div className="flex flex-col gap-4 font-medium leading-5">
                        <div className="p-[10px] border-b border-[#EAEAEA]">
                            <div className="size-20 rounded-full overflow-hidden flex items-center justify-center bg-[#EAEAEA]">
                                {
                                    storeInfo.img ? 
                                    <img className='size-full' src={getCachedMediaUrl(storeInfo.img)} alt={storeInfo.storeName || ''} /> : 
                                    <h1 className='font-semibold text-3xl text-[#666666]'>{getInitials(storeInfo.storeName || '')}</h1>
                                }
                            </div>
                        </div>

                        <SectionBox 
                            icon={StoreIcon} 
                            title={'Store Name'} 
                            value={storeInfo.storeName} 
                            border 
                        />

                        <SectionBox 
                            icon={StoreIcon} 
                            title={'Store Description'} 
                            value={storeInfo.storeDescription} 
                            border 
                        />

                        <SectionBox 
                            icon={StoreIcon} 
                            title={'Store Category'} 
                            value={storeInfo.storeCategory} 
                            border 
                        />

                        <SectionBox 
                            icon={StoreIcon} 
                            title={'Target Audience'} 
                            value={storeInfo.targetAudience} 
                            border 
                        />

                        <SectionBox 
                            icon={HomeIcon} 
                            title={'Store Address'} 
                            value={`${storeInfo.storeAddress}${storeInfo.storeCity}, ${storeInfo.storeState} - ${storeInfo.storePincode}`} 
                            border 
                        />

                        <SectionBox 
                            icon={HomeIcon} 
                            title={'Warehouse Address'} 
                            value={`${storeInfo?.warehouseAddr?.Addr}${storeInfo?.warehouseAddr?.city}, ${storeInfo?.warehouseAddr?.state} - ${storeInfo?.warehouseAddr?.pincode}`} 
                        />
                    </div>
                </div>
            }
        </div>
    );
}

export default StoreInfo;
